import { render, staticRenderFns } from "./PermissionBox.vue?vue&type=template&id=593f0985&scoped=true&"
import script from "./PermissionBox.vue?vue&type=script&lang=js&"
export * from "./PermissionBox.vue?vue&type=script&lang=js&"
import style0 from "./PermissionBox.vue?vue&type=style&index=0&id=593f0985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f0985",
  null
  
)

export default component.exports